import { render } from "./statustagmenu.vue?vue&type=template&id=a07f5b1a"
import script from "./statustagmenu.vue?vue&type=script&lang=js"
export * from "./statustagmenu.vue?vue&type=script&lang=js"

import "./statustagmenu.vue?vue&type=style&index=0&id=a07f5b1a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__